import React from 'react';
import ProgressContainer from 'containers/player/controlbar/ProgressContainer';
import PlayPauseContainer from 'containers/player/controlbar/PlayPauseContainer';
import SkipContainer from 'containers/player/controlbar/SkipContainer';
import VolumeContainer from 'containers/player/controlbar/VolumeContainer';
import TimeContainer from 'containers/player/controlbar/TimeContainer';
import SettingContainer from 'containers/player/controlbar/SettingContainer';

/**
 * 플레이어 > 컨트롤 바 영역
 */

const ControlBar: React.FC = () => {
  return (
    <div className='player_ctrlBox'>
      <div className='ctrlBox'>
        <div className='ctrl'>
          <ProgressContainer />
          <PlayPauseContainer />
          <SkipContainer />
          <VolumeContainer />
          <TimeContainer />
        </div>
        <div className='right_ctrl'>
          <SettingContainer />
        </div>
      </div>
    </div>
  );
};

export default ControlBar;
